export default {
  products: [],
  deliveryMethod: null,
  paymentMethodId: 1,
  coupon: null,
  useCredit: false,
  lastOrder: null,
  currentProductIndex: null,
  currentSelectedOptions: null,
  currentSelectedSideOptions: null,
  currentProductQuantity: null,
  readyTime: null,
  totalPrice: 0,
  totalDiscount: 0,
  distancing: 0,
  paymentData: null,
  deliveryMethodData: null,
};
